import { gql } from '@apollo/client';

export const userListingBook = gql`
query UserListing($listId:Int!) {
  UserListing (listId:$listId) {
    id
    userId
    title
    coverPhoto
    country
    city
    state
    personCapacity
    bookingType
    reviewsCount
    reviewsStarRating
    beds
    listPhotos{
      id
      name
    }
    user {
      id
      email
      profile{
        profileId
        displayName
        firstName
        picture
      }
    }
    settingsData {
      id
      settingsId
      listsettings {
        id
        itemName
        settingsType {
          typeName
        }
      }
    }
    houseRules {
      houseRulesId
      listsettings{
        itemName
        isEnable
        settingsType {
          typeName
        }
      }
    }
    listingData {
      checkInStart,
      checkInEnd,
      basePrice,
      cleaningPrice,
      tax,
      currency,
      weeklyDiscount,
      monthlyDiscount,
      taxRate
      petFee
      cancellation {
        id
        policyName
        policyContent
      }
    }
    listBlockedPrice {
      id
      listId
      isSpecialPrice
      blockedDates
    }
  }
}
`;

export const createReservation = gql`
    mutation createReservation(
      $listId: Int!, 
      $hostId: String!,
      $guestId: String!,
      $checkIn: String!,
      $checkOut: String!,
      $guests: Int!,
      $message: String!,
      $basePrice: Float!,
      $cleaningPrice: Float,
      $taxPrice: Float,
      $currency: String!,
      $discount: Float,
      $discountType: String,
      $guestServiceFee: Float,
      $hostServiceFee: Float,
      $total: Float!,
      $bookingType: String,
      $paymentType: Int!,
      $cancellationPolicy: Int!,
      $specialPricing: String,
      $isSpecialPriceAssigned: Boolean,
      $isSpecialPriceAverage: Float,
      $dayDifference: Float,
      $taxRate: Float,
      $checkInStart: String,
      $checkInEnd: String,
      $hostServiceFeeType: String,
      $hostServiceFeeValue: Float,
      $threadId: Int
      $guestServiceFeeType: String,
      $guestServiceFeeValue: Float,
      $petFee: Float
    ){
        createReservation(
          listId: $listId,
          hostId: $hostId,
          guestId: $guestId,
          checkIn: $checkIn,
          checkOut: $checkOut,
          guests: $guests,
          message: $message,
          basePrice: $basePrice,
          cleaningPrice: $cleaningPrice,
          taxPrice: $taxPrice,
          currency: $currency,
          discount: $discount,
          discountType: $discountType,
          guestServiceFee: $guestServiceFee,
          hostServiceFee: $hostServiceFee,
          total: $total,
          bookingType: $bookingType,
          paymentType: $paymentType,
          cancellationPolicy: $cancellationPolicy,
          specialPricing: $specialPricing,
          isSpecialPriceAssigned: $isSpecialPriceAssigned,
          isSpecialPriceAverage: $isSpecialPriceAverage,
          dayDifference: $dayDifference,
          taxRate: $taxRate,
          checkInStart: $checkInStart,
          checkInEnd: $checkInEnd,
          hostServiceFeeType: $hostServiceFeeType,
          hostServiceFeeValue: $hostServiceFeeValue,
          threadId: $threadId
          guestServiceFeeType: $guestServiceFeeType
          guestServiceFeeValue: $guestServiceFeeValue
          petFee: $petFee
        ) {
            id
            listId,
            hostId,
            guestId,
            checkIn,
            checkOut,
            guests,
            message,
            basePrice,
            cleaningPrice,
            taxPrice,
            currency,
            discount,
            discountType,
            guestServiceFee,
            hostServiceFee,
            total,
            confirmationCode,
            createdAt
            status
            paymentMethodId,
            cancellationPolicy,
            isSpecialPriceAverage,
            dayDifference,
            taxRate, 
            checkInStart,
            checkInEnd,
            hostServiceFeeType,
            hostServiceFeeValue,
            guestServiceFeeType
            guestServiceFeeValue
            petFee
        }
    }
    `;

export const getPaymentState = gql`
    query getPaymentState($reservationId: Int!){
      getPaymentState(reservationId: $reservationId){
        paymentState
        errorMessage
        status
      }
    }
    `;

export const cancelReservation = gql`
    mutation cancelReservation(
    $reservationId: Int!,
    $cancellationPolicy: String!,
    $refundToGuest: Float!,
    $payoutToHost: Float!,
    $guestServiceFee: Float!,
    $hostServiceFee: Float!,
    $total: Float!,
    $currency: String!,
    $threadId: Int!,
    $cancelledBy: String!,
    $message: String!,
    $checkIn: String!,
    $checkOut: String!,
    $guests: Int!,
    $isTaxRefunded: Boolean!,
    ){
    cancelReservation(
      reservationId: $reservationId,
      cancellationPolicy: $cancellationPolicy,
      refundToGuest: $refundToGuest,
      payoutToHost: $payoutToHost,
      guestServiceFee: $guestServiceFee,
      hostServiceFee: $hostServiceFee,
      total: $total,
      currency: $currency,
      threadId: $threadId,
      cancelledBy: $cancelledBy,
      message: $message,
      checkIn: $checkIn,
      checkOut: $checkOut,
      guests: $guests,
      isTaxRefunded: $isTaxRefunded
    ) {
        status
    }
    }
    `;

export const updateReservation = gql`
    mutation updateReservation(
      $reservationId: Int!, 
      $actionType: String!,
      $threadId: Int
    ){
        updateReservation(
          reservationId: $reservationId,
          actionType: $actionType,
          threadId: $threadId
        ) {
            status
        }
    }
    `;

export const reservationCount = gql`
    query getUpcomingBookings ($listId: Int!){
        getUpcomingBookings(listId: $listId){
          count
        }
      }`;
      